import { useEffect } from 'react';
import { useStore } from '@/store';
import { selectTheme } from '@/store/selectors';

/**
 * Resolve the active theme and apply it to <html data-theme> (F-060).
 */
export function useTheme(): 'light' | 'dark' {
  const theme = useStore(selectTheme);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  // Re-resolve when the OS preference changes (system mode).
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => {
      const settings = useStore.getState().settings;
      if (settings.theme === 'system') {
        document.documentElement.dataset.theme = mql.matches ? 'dark' : 'light';
      }
    };
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return theme;
}
